import { Injectable } from '@angular/core';
import { UserPreferencesNotificatorByExternalTaskService } from '@nimbus-library/features/user-settings/services/user-preferences-notification-sender/user-preferences-notificators/user-preferences-notificator-by-external-task.service';
import { UserPreferencesNotificatorByEmailService } from '@nimbus-library/features/user-settings/services/user-preferences-notification-sender/user-preferences-notificators/user-preferences-notificator-by-email.service';
import { UserPreferencesNotificatorByInstantMessageService } from '@nimbus-library/features/user-settings/services/user-preferences-notification-sender/user-preferences-notificators/user-preferences-notificator-by-instant-message.service';
import { UserPreferencesNotificatorByPickupService } from '@nimbus-library/features/user-settings/services/user-preferences-notification-sender/user-preferences-notificators/user-preferences-notificator-by-pickup.service';

@Injectable({ providedIn: 'root' })
export class UserPreferencesNotificationSenderService {
  public constructor(
    private readonly userPreferencesNotificatorByExternalTaskService: UserPreferencesNotificatorByExternalTaskService,
    private readonly userPreferencesNotificatorByEmailService: UserPreferencesNotificatorByEmailService,
    private readonly userPreferencesNotificatorByInstantMessageService: UserPreferencesNotificatorByInstantMessageService,
    private readonly userPreferencesNotificatorByPickupService: UserPreferencesNotificatorByPickupService,
  ) {}

  public initialize(): void {
    this.userPreferencesNotificatorByExternalTaskService.initialize();
    this.userPreferencesNotificatorByEmailService.initialize();
    this.userPreferencesNotificatorByInstantMessageService.initialize();
    this.userPreferencesNotificatorByPickupService.initialize();
  }
}
